import * as React from 'react';
import useComponentSize from '@rehooks/component-size';
import { Grid } from './grid';
import { IResizableGridSurfaceProps, IResizableGridContext } from './grid-props';
import { MoveableSurface, IMoveableSurfaceContextProps, IMoveableSurfaceProps } from '../moveable';

const MoveableGridSurface: React.ComponentType<IMoveableSurfaceProps<IMoveableSurfaceContextProps<IResizableGridContext>>> = MoveableSurface;

export const ResizableGridSurface = React.memo((props: IResizableGridSurfaceProps) => {
    const { children, context, ...gridProps } = props;
    const hostRef = React.useRef(null);
    const size = useComponentSize(hostRef);
    const onRender = React.useCallback((ref) => (
        <Grid {...gridProps} elementRef={ref as React.RefObject<HTMLDivElement>}>{children}</Grid>
    ), [children, gridProps]);
    return (
        <MoveableGridSurface context={{ ...context, containerRef: hostRef, unitSize: size.width / context.maxUnits }}>
            {onRender}
        </MoveableGridSurface>
    );
});

ResizableGridSurface.displayName = 'ResizableGridSurface';
